// ── 核心交互逻辑 (Core Interactions) ──

// 图片切换函数 (Gallery Switcher)
window.sw = function(i) {
  const mainImage = document.getElementById('mi');
  const srcs = window.SRL_GALLERY_IMAGES || [];
  if (mainImage && srcs[i]) {
    mainImage.src = srcs[i];
  }
  // 切换缩略图的高亮状态
  document.querySelectorAll('.g-thumb').forEach((t, n) => {
    t.classList.toggle('on', n == i);
  });
};

// 军规：使用事件委托处理全局点击 (Event Delegation)
document.addEventListener('click', function(e) {
  // 1. FAQ 展开/折叠逻辑
  const faqQ = e.target.closest('.faq-q');
  if (faqQ) {
    const a = faqQ.nextElementSibling;
    const item = faqQ.closest('.faq-item');
    if (!a || !item) return;
    const isOpen = a.classList.contains('open');
    // 关闭所有其他 FAQ
    document.querySelectorAll('.faq-a.open').forEach(x => x.classList.remove('open'));
    document.querySelectorAll('.faq-item.active').forEach(x => x.classList.remove('active'));
    // 切换当前 FAQ
    if (!isOpen) {
      a.classList.add('open');
      item.classList.add('active');
    }
    return; // 处理完 FAQ 逻辑，直接返回
  }

  // 2. 相册图片切换逻辑 (基于 data-index)
  const thumb = e.target.closest('.g-thumb');
  if (thumb) {
    const index = thumb.getAttribute('data-index');
    if (index !== null) {
      window.sw(parseInt(index));
    }
  }
});

// 强制把结账页右上角购物车图标链接改为首页
document.addEventListener('DOMContentLoaded', function () {
  const cartLink = document.getElementById('cart-link');
  if (cartLink) {
    cartLink.setAttribute('href', '/');
    cartLink.setAttribute('aria-label', 'Home');
  }

  initMobileNav();
  initMobileStickyCta();
});

function initMobileNav() {
  const menuBtn = document.getElementById('nav-menu-btn');
  const menu = document.getElementById('nav-mobile-menu');
  if (!menuBtn || !menu) return;

  function setMenuOpen(open) {
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    menu.hidden = !open;
  }

  menuBtn.addEventListener('click', () => {
    setMenuOpen(menu.hidden);
  });

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setMenuOpen(false));
  });

  document.addEventListener('click', (e) => {
    if (menu.hidden) return;
    if (!menu.contains(e.target) && !menuBtn.contains(e.target)) {
      setMenuOpen(false);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !menu.hidden) setMenuOpen(false);
  });
}

function initMobileStickyCta() {
  const sticky = document.getElementById('srl-mobile-sticky-cta');
  const stickyBtn = document.getElementById('srl-mobile-sticky-btn');
  const buySection = document.getElementById('buy');
  if (!sticky || !stickyBtn) return;

  const mq = window.matchMedia('(max-width: 820px)');

  stickyBtn.addEventListener('click', () => {
    if (buySection) {
      buySection.scrollIntoView({ behavior: 'smooth' });
    }
  });

  function updateSticky() {
    if (!mq.matches) {
      sticky.hidden = true;
      sticky.classList.remove('is-visible');
      return;
    }

    sticky.hidden = false;
    const scrollY = window.scrollY;
    const buyTop = buySection ? buySection.getBoundingClientRect().top + scrollY : Infinity;
    const buyVisible = buySection && buySection.getBoundingClientRect().top < window.innerHeight * 0.6
      && buySection.getBoundingClientRect().bottom > 0;
    const show = scrollY > 420 && !buyVisible;

    sticky.classList.toggle('is-visible', show);
  }

  window.addEventListener('scroll', updateSticky, { passive: true });
  mq.addEventListener('change', updateSticky);
  updateSticky();
}
function fixCheckoutCartLink() {
  const cartLink = document.getElementById('cart-link');
  if (cartLink) {
    cartLink.href = '/';
    cartLink.setAttribute('aria-label', 'Home');
  }
}
// 初始执行
fixCheckoutCartLink();
// 防止 Shopify 异步重绘
const observer = new MutationObserver(fixCheckoutCartLink);
observer.observe(document.body, { childList: true, subtree: true });
